<template>
  <header class="flex-shrink-0">
    <div class="flex w-full items-center justify-between">
      <h1 class="m-0 text-[24px] font-bold leading-[32px] text-gray-600">
        {{ headerTitle }}
      </h1>
      <div class="flex items-center gap-3">
        <div v-if="!hasActiveSegments" class="relative inline-flex">
          <button-v2
            variant="outline"
            size="md"
            icon-left="filter_alt"
            @click="toggleFilter"
          >
            {{ $t('CONTACTS_PAGE.FILTER_CONTACTS') }}
          </button-v2>
          <span v-if="hasAppliedFilters" class="contacts-filter-dot" />
        </div>

        <button-v2
          v-if="!newRulesSystemEnabled || hasCreatePermission('Contacts')"
          variant="outline"
          size="md"
          icon-left="download"
          @click="toggleImport"
        >
          {{ $t('IMPORT_CONTACTS.BUTTON_LABEL') }}
        </button-v2>

        <button-v2
          v-if="!newRulesSystemEnabled || hasCreatePermission('Contacts')"
          variant="filled"
          size="md"
          icon-left="add"
          @click="toggleCreate"
        >
          {{ $t('CREATE_CONTACT.BUTTON_LABEL') }}
        </button-v2>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import ButtonV2 from 'v2/components/Button/ButtonV2.vue';

export default {
  components: { ButtonV2 },
  mixins: [hasPermissionMixin],
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    searchQuery: {
      type: String,
      default: '',
    },
    segmentsId: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      showCreateModal: false,
      showImportModal: false,
    };
  },
  computed: {
    ...mapGetters({
      getAppliedContactFilters: 'contacts/getAppliedContactFilters',
      getAccount: 'accounts/getAccount',
      accountId: 'getCurrentAccountId',
    }),
    hasAppliedFilters() {
      return this.getAppliedContactFilters.length;
    },
    hasActiveSegments() {
      return this.segmentsId !== 0;
    },
    account() {
      return this.getAccount(this.accountId);
    },
    newRulesSystemEnabled() {
      return this.account?.features?.new_rules_system;
    },
  },
  methods: {
    toggleCreate() {
      this.$emit('on-toggle-create');
    },
    toggleFilter() {
      this.$emit('on-toggle-filter');
    },
    toggleImport() {
      this.$emit('on-toggle-import');
    },
    submitSearch() {
      this.$emit('on-search-submit');
    },
    inputSearch(event) {
      this.$emit('on-input-search', event);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .button-v2--filled.button-v2--md {
  padding: 8px 12px;
}

.contacts-filter-dot {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: theme('colors.brand.DEFAULT');
  z-index: 1;
}
</style>
